import CryptoJS from 'crypto-js';
import config from '../config';

const TOKEN_KEY = 'accessToken';

function parseAesParams() {
  if (!config.secretKey || !config.initializationVector) {
    return null;
  }
  return {
    key: CryptoJS.enc.Hex.parse(config.secretKey),
    iv: CryptoJS.enc.Hex.parse(config.initializationVector),
  };
}

export function getStoredAccessToken() {
  const encrypted = localStorage.getItem(TOKEN_KEY);
  if (!encrypted) {
    return null;
  }

  const params = parseAesParams();
  if (!params) {
    return null;
  }

  try {
    const decrypted = CryptoJS.AES.decrypt(encrypted, params.key, { iv: params.iv });
    const token = decrypted.toString(CryptoJS.enc.Utf8);
    return token || null;
  } catch (error) {
    console.error('No se pudo leer el token de sesión:', error);
    return null;
  }
}

export function storeAccessToken(access) {
  const params = parseAesParams();
  if (!params || !access) {
    throw new Error('No hay clave de cifrado configurada para guardar la sesión');
  }
  const encrypted = CryptoJS.AES.encrypt(access, params.key, { iv: params.iv });
  localStorage.setItem(TOKEN_KEY, encrypted.toString());
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
}

export function hasStoredToken() {
  return Boolean(localStorage.getItem(TOKEN_KEY));
}
